module.exports = __webpack_public_path__ + "static/img/help_06_05s.adb1e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_06_05s.jpg
// module id = 700
// module chunks = 140